import {useContext, useRef} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import MoleculeAvatar, {moleculeAvatarBadgeSizes} from '@s-ui/react-molecule-avatar'

const BASE_CLASS = 'mt-userProfileEdit-formUserAvatar'
const FALLBACK_COLOR = '#242f44' // $c-primary-l

const FormUserAvatar = ({userData: {avatar, lastName, name, userId}}) => {
  const {domain, i18n} = useContext(Context)
  const inputRef = useRef()
  const config = domain.get('config')
  const {UPDATE_USER_AVATAR_ENABLED} = config.get('user')

  const userName = lastName ? `${name} ${lastName}` : name

  const handleModifyAvatarClick = async () => {
    inputRef.current.click()
  }

  const handleChangeInput = event => {
    console.log(`Modify Avatar for user ${userId}`)
    const image = event.target.files[0]
    if (!image) {
      console.log('no file')
      return
    }
    console.log(`execute domain use case with ${image}`)
  }

  const handleInvalidInput = event => {
    console.log('invalid')
  }

  return (
    <div className={BASE_CLASS}>
      <MoleculeAvatar
        src={avatar}
        size={moleculeAvatarBadgeSizes.XXLARGE}
        name={userName}
        fallbackColor={FALLBACK_COLOR}
      />
      <input
        accept="image/jpeg, image/gif, image/png, image/webp, image/bmp"
        className={`${BASE_CLASS}-input`}
        multiple={false}
        onChange={handleChangeInput}
        onInvalid={handleInvalidInput}
        ref={inputRef}
        type="file"
      />
      {UPDATE_USER_AVATAR_ENABLED && (
        <div className={`${BASE_CLASS}-button`}>
          <AtomButton
            design={atomButtonDesigns.LINK}
            disabled
            onClick={handleModifyAvatarClick}
            size={atomButtonSizes.SMALL}
          >
            {i18n.t('USER_PROFILE.EDIT.UPDATE_AVATAR_BUTTON_TEXT')}
          </AtomButton>
          <span className={`${BASE_CLASS}-buttonLabel`}>Para modificarla debes hacerlo en la app</span>
        </div>
      )}
    </div>
  )
}

FormUserAvatar.displayName = 'FormUserAvatar'

FormUserAvatar.propTypes = {
  userData: PropTypes.object
}

export default FormUserAvatar
